import React from 'react';
import { HelpCircle } from 'lucide-react';

const HelpSection = () => {
  return (
    <div className="help-section">
      <div className="d-flex align-items-start gap-3">
        <HelpCircle className="text-secondary" size={24} />
        <div>
          <h4 className="fw-medium help-title mb-2">Having trouble?</h4>
          <p className="text-secondary small mb-3">
            Feel free to contact us and we will always help you through the process
          </p>
          <button className="contact-btn">Contact us</button>
        </div>
      </div>
    </div>
  );
};

export default HelpSection;